/**
 * 封装 axios 请求模块
 */
import axios from "axios";
import router from "@/router";

const baseURL = "https://kplapi.zonln.cn/admin.php" 
// const baseURL = "https://api.kaiple-sale.com/admin.php" 
window.localStorage.setItem('baseURL', baseURL)

const request = axios.create({
  baseURL: baseURL,
});

// 请求拦截器
request.interceptors.request.use((cfg) => {
  let token = window.localStorage.getItem('token') || ''
  cfg.data.token = token
  // cfg.headers['token'] = token
  return cfg;
});

// 响应拦截器
request.interceptors.response.use(
  res => {
    if (res.status === 200) {
      let data = res.data
      if (data.code === 501) {
        window.localStorage.setItem('token', '')
        router.push('/login')
        return Promise.resolve(res.data)
      } else {
        return Promise.resolve(res.data)
      }
    } else {
      Promise.reject(res)
    }
  },
  err => {
    return Promise.reject(err)
  }
)

export default request;
